import React from 'react';
import { Avatar, Box, Checkbox, MenuItem, Typography } from '@mui/material';
import { CheckIcon } from 'src/Icons';

interface SelectStudioMenuItem {
    checked: boolean;
    imageSrc: string;
    title: string;
    value: string;
  }

export const SelectStudioMenuItem = (
  {
    value,
    checked,
    imageSrc,
    title,
    ...rest
  }: SelectStudioMenuItem) => {
  return (
    <MenuItem
      value={value}
      disableRipple
      {...rest}
    >
      <Checkbox
        checked={checked}
        icon={<></>}
        checkedIcon={<CheckIcon fontSize="inherit" />}
        sx={{
          width: '24px',
          height: '24px',
          borderRadius: '6px',
          border: '1px solid #667085',
          fontSize: '16px',
          marginRight: '16px',

          '&:hover': {
            borderColor: '#BF295C',
            boxShadow: '#FFF2F7 0px 0px 0px 4px',
          },

          '&.Mui-checked': {
            backgroundColor: '#FFF8FA',
            borderColor: '#BF295C',
            color: '#F56193',
          },

          '& .MuiSvgIcon-root': {
            position: 'relative',
            top: '-1px',
          },
        }}
        disableRipple
      />
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Avatar
          src={imageSrc}
          sx={{
            width: '24px',
            height: '24px',
            marginRight: '8px',
          }}
        />
        <Typography>{title}</Typography>
      </Box>
    </MenuItem>
  );
};